import { ReactNode } from 'react';

import { Stack, useTheme } from '@mui/material';

import clsx from 'clsx';

import Typography from '../../../components/Typography';
import { layoutClasses, Root, StyledUserCell } from './styles';
import useLayoutVM from './vm';
import AcadlyLogoSquareIcon from '../../../icons/AcadlyLogoSquare';

export interface Props {
  title: ReactNode;
  subtitle?: ReactNode;
  canSeeUserCell?: boolean;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
  classes?: Partial<Record<keyof typeof layoutClasses, string>>;
}

export { layoutClasses };

const Layout = ({ title, subtitle, children, footer, className, classes, canSeeUserCell }: Props) => {
  const theme = useTheme();

  const { session } = useLayoutVM();

  return (
    <Root
      elevation={theme.palette.mode === 'dark' ? 6 : 0}
      className={clsx(layoutClasses.root, className, classes?.root)}
    >
      <AcadlyLogoSquareIcon size={32} />
      <Stack flex={1} gap={4}>
        <Stack gap={2} className={clsx(layoutClasses.contentHeader, classes?.contentHeader)}>
          {typeof title === 'string' ? (
            <Typography
              variant="h5Medium"
              color="common.black"
              className={clsx(layoutClasses.title, classes?.title)}
            >
              {title}
            </Typography>
          ) : (
            title
          )}
          {subtitle &&
            (typeof subtitle === 'string' ? (
              <Typography
                variant="paragraphRegular"
                color="grey.500"
                className={clsx(layoutClasses.subtitle, classes?.subtitle)}
              >
                {subtitle}
              </Typography>
            ) : (
              subtitle
            ))}
          {canSeeUserCell && session && (
            <StyledUserCell
              classes={{
                root: clsx(layoutClasses.userCell, classes?.userCell),
                avatar: clsx(layoutClasses.avatar, classes?.avatar),
              }}
              avatar={session.avatar}
              title={session.name}
              subtitle={session.university.name}
              size="medium"
            />
          )}
        </Stack>
        <Stack flex={1} className={clsx(layoutClasses.content, classes?.content)}>
          {children}
        </Stack>
        {footer && (
          <Stack className={clsx(layoutClasses.contentFooter, classes?.contentFooter)}>{footer}</Stack>
        )}
      </Stack>
    </Root>
  );
};

export default Layout;
